export default __webpack_public_path__ + "static/media/CoClient-02.7fadb407.svg";